import { ChangeEvent, useRef } from 'react';
import { Box } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';

type UploadMarkdownButtonProps = {
  onSelectFile: (file: File) => Promise<void> | void;
};

const UploadMarkdownButton = ({ onSelectFile }: UploadMarkdownButtonProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileUpload = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    await onSelectFile(file);
    event.target.value = '';
  };

  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center" mb={1.5}>
      <input ref={inputRef} type="file" accept=".md,text/markdown" hidden onChange={handleFileUpload} />
      <Button color="primary" variant="outlined" onClick={() => inputRef.current?.click()}>
        Upload .md doc
      </Button>
    </Box>
  );
};

export default UploadMarkdownButton;
